export default `
.root-menu {
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
a {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  position: relative;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--g-theme-color-text);
}
ul, li {
  padding: 0;
  margin: 0;
}
li {
  margin-bottom: 8px;
  list-style: none;
  position: relative;
}
li:last-child {
  margin-bottom: 0;
}
.group-line {
  background-color: var(--g-theme-sidebar-divider);
  height: 1px;
  width: calc(100% - 24px);
  margin-left: 12px;
}
.level2 {
  padding: 0 8px;
  border-radius: 12px;
  background-color: var(--g-theme-sidebar-expand-bg);
}
.min-size.level1 {
  padding: 0 8px;
  width: 38px;
  overflow: hidden;
}
.min-size label {
  font-size: 14px;
  height: 38px;
  line-height: 38px;
}
.min-size .level2 label,
.min-size .level3 label {
  font-size: 14px;
  height: 34px;
  line-height: 34px;
}
.min-size label.root-menu {
  justify-content: center;
  margin: 0 auto;
}
.min-size .level3 .active {
  color: var(--g-theme-color)!important;
  background: var(--g-theme-sidebar-collapse-bg-active)!important;
  border: none;
  border-radius: 4px;
}
.min-size > li {
  margin-bottom: 8px;
}
.min-size .group-line {
  width: 100%;
  margin: 0 0 12px;
}
.min-size > li > a {
  margin: 0;
  padding: 0;
  text-align: center;
  width: 38px;
  height: 38px;
  line-height: 38px;
  border-radius: 8px;
}

.min-size > li > a:hover {
  background: var(--g-theme-sidebar-bg-hover);
}
.min-size > li i.layout {
  margin-right: 0;
}
.min-size > li label.root-menu span {
  display: none;
}
.min-size > li > a.active i.layout[class$="light"] {
  color: var(--g-theme-sidebar-color-text-active);
  display: inline-block !important;
}
.min-size > li > a:hover ~ ul.level2:not(.collapsed-panel) {
  display: none !important;
}
/* 折叠模式下二级菜单悬浮面板 */
.min-size .level2.collapsed-panel, .min-size .level3.collapsed-panel {
  display: block !important;
  position: fixed;
  left: 62px;
  z-index: 1800;
  width: calc(166px - 8px);
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 4px 0;
}
.level2-menu-title {
  display: none;
  color: rgba(69, 60, 90, 0.6);
  font-size: 14px;
  font-weight: 600;
  line-height: 32px;
  height: 32px;
  margin-bottom: 0px;
  margin-top: 4px;
  margin-left: 4px;
  padding: 0 12px;
}
.min-size .level2.collapsed-panel .level2-menu-title {
  display: block;
}
.min-size .level2 a, .min-size .level3 a {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  padding: 0px 12px;
  margin: 0 4px;
  overflow: hidden;
  color: #1d1c23;
}
.min-size .level2 a:hover, .min-size .level3 a:hover {
  background: var(--g-theme-sidebar-collapse-bg-hover);
}
/* 折叠模式下三级菜单悬浮面板 */
.min-size .level3.collapsed-panel {
  display: block !important;
  z-index: 1801;
}
// .min-size .tri-down:after {
//   top: 8px;
// }

/* 折叠模式下二级面板左侧三角箭头，指向一级菜单项 */
.min-size .level2-arrow {
  position: fixed;
  left: 59px;
  z-index: 1802;
  pointer-events: none;
}
.min-size .level2-arrow::after {
  content: '';
  width: 0;
  height: 0;
  padding: 3px;
  background: #ffffff;
  position: absolute;
  top: -3px;
  transform: rotate(45deg);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}
.min-size .level2-arrow::before {
  content: '';
  width: 0;
  height: 0;
  padding: 10px 4px;
  background: #ffffff;
  position: absolute;
  top: -9px;
  left: 3px;
  z-index: 1;
}

.min-size .level2input:checked + .tri-down label:after {
  top: 12px;
}
.min-size .level1input + .tri-down label:after {
  right: -10px !important;
}
.min-size input:checked ~ .level2,
.min-size input:checked ~ .level3 {
  display: none !important;
}
/* 折叠模式下hover面板优先，覆盖checkbox隐藏规则 */
.min-size .level3.collapsed-panel {
  display: block !important;
}
/* 一级面板：右侧桥接 */
.min-size.level1 > li::after {
  content: '';
  position: absolute;
  top: 0;
  right: -17px;
  width: 19px;
  height: 100%;
  z-index: -1;
}
/* 二级面板：左侧桥接 */
.min-size .level2.collapsed-panel > li::before {
  content: '';
  position: absolute;
  top: 0;
  left: -8px;
  width: 8px;
  height: 100%;
  z-index: -1;
}
/* 三级面板：左侧桥接 */
.min-size .level3.collapsed-panel > li::before {
  content: '';
  position: absolute;
  top: 0;
  left: -12px;
  width: 12px;
  height: 100%;
  z-index: -1;
}
/* 二级面板：右侧桥接（含三级子菜单的li，衔接二级面板与三级面板之间的间隙） */
.min-size .level2.collapsed-panel > li:has(> ul.level3)::after {
  content: '';
  position: absolute;
  top: 0;
  right: -4px;
  width: 8px;
  height: 100%;
  z-index: 0;
}
/* 三级面板：左侧桥接扩展（覆盖到二级面板右侧边缘） */
.min-size .level3.collapsed-panel::before {
  content: '';
  position: absolute;
  top: 0;
  left: -8px;
  width: 8px;
  height: 100%;
  z-index: 0;
}

input:checked ~ ul {
  display: block !important;
}

label {
  display: block;
  width: calc(100% -  16px);
  user-select: none;
  cursor: pointer;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.level3 label {
  color: var(--g-theme-sidebar-color-text-last);
}

i.layout {
  min-width: 18px;
  font-size: 18px;
  font-weight: 400;
  color: var(--g-theme-color-text);
  margin-right: 8px;
}

.level1 {
  padding: 0 8px;
  background: var(--g-theme-sidebar-bg);
}
.level1 a {
  border-radius: 6px;
  background: transparent;
  padding-left: 14px;
  font-weight: 400;
  font-size: 14px;
  border: none;
  height: 38px;
}
.level1 a:hover {
  background: var(--g-theme-sidebar-bg-hover);
  color: var(--g-theme-color);
}
.level1 a:hover i.layout {
  color: var(--g-theme-color);
}
.min-size .level1 a {
  margin: 0
}
.level2, .level3 {
  margin-top: 8px;
}
.min-size .level2, .min-size .level3 {
  margin-top: 0;
}
.level2 a {
  padding-left: 36px;
  padding-right: 0;
}
.level2 label {
  font-size: 12px;
}
.level3 a {
  font-size: 12px;
  padding-left: 42px;
  color: var(--g-theme-sidebar-color-text-last);
}

.menu {
  line-height: normal !important;
}
.active {
  color: var(--g-theme-sidebar-color-text-active) !important;
  background: var(--g-theme-sidebar-bg-active) !important;
  font-weight: 600 !important;
}
.active i.layout[class$="gray"] {
  display: none;
}
.active i.layout[class$="light"] {
  color: var(--g-theme-sidebar-color-text-active)!important;
  display: inline-block !important;
}
.level1 .activelink {
  color: var(--g-theme-color-text);
  font-weight: 600;
}
.level1 .activelink i.layout[class$="gray"] { display: none; }
.level1 .activelink i.layout[class$="light"] {
  color: var(--g-theme-color-text);
  display: inline-block !important;
}
.min-size.level1 .activelink {
  color: var(--g-theme-sidebar-color-text-active) !important;
  background: var(--g-theme-sidebar-collapse-bg-active) !important;
  font-weight: 600 !important;
}
.min-size.level1 .activelink i.layout {
  color: var(--g-theme-sidebar-color-text-active) !important;
  font-weight: 600 !important;
}
.min-size .level2 .activelink {
  color: var(--g-theme-color) !important;
  background: var(--g-theme-sidebar-collapse-bg-active) !important;
  font-weight: 600 !important;
}
.min-size .level2 .activelink i.layout {
  color: var(--g-theme-color) !important;
  font-weight: 600 !important;
}
.level1_dark .activelink {
  // color: #ffffff !important;
}
.level1_dark .activelink img {
  filter: brightness(0) invert(1);
}
.level1input:checked + .tri-down  label:after {
  top: 17px;
  transform: rotate(-135deg);
}
.level1input:checked + .tri-down label {
  // font-weight: 600;
}
.level2input:checked + .tri-down label:after {
  top: 17px;
  transform: rotate(-135deg);
}
.level2input:checked + .tri-down label {
  // font-weight: 600;
}

.mark:before {
  content: '';
  width: 6px;
  height: 6px;
  background: rgba(255, 41, 16, 1);
  border-radius: 50%;
  position: absolute;
  overflow: hidden;
  top: 7px;
  right: unset;
  left: 26px;
}

.level2 .mark:before {
  right: unset;
  left: 26px;
  top: 5px;
}
.level3 .mark:before {
  right: unset;
  left: 36px;
  top: 6px;
}
.min-size > li .mark:before {
  left: unset;
  right: 6px;
  top: 6px;
}
.min-size .level2 .mark:before, .min-size .level3 .mark:before {
  right: unset;
  left: 5px;
  top: 6px;
}

.tri-down label:after {
  content: '';
  width: 0;
  height: 0;
  padding: 2.5px;
  border-right: 1.5px solid var(--g-theme-sidebar-icon-color);
  border-bottom: 1.5px solid var(--g-theme-sidebar-icon-color);
  border-top: none;
  position: absolute;
  top: 14px;
  right: 12px;
  transform: rotate(45deg);
  transition: transform 0.2s;
}
.level2 .tri-down label:after {
  right: 4px;
}
.level1.min-size .tri-down label:after {
  border-right: none;
  border-top: none;
  border-bottom: none;
}
.level1 > li > .tri-down label:after {
  top: 14px;
}

.min-size .level2 .tri-down label:after {
  top: 12px;
  right: 10px;
  padding: 3px;
  border-right: 1.2px solid rgba(69, 60, 90, 0.5);
  border-top: 1.2px solid rgba(69, 60, 90, 0.5);
  border-bottom: none;
}
.level1_dark {
  background: #150448;
}
.level1_dark a {
  color: #deded0;
}
.level1_dark .active {
  color: #ffffff !important;
  font-weight: 600;
  border-right-style: solid;
  border-right-width: 4px;
  border-color: #8b60f0;
  background: linear-gradient(270deg, #5C2ED4 0%, #3C0D8D 100%) !important;
}
.level1_dark .active i.layout[class$="gray"] {
  display: none;
}
.level1_dark .active i.layout[class$="light"] {
  color: #ffffff !important;
  display: inline-block !important;;
}
.level1_dark .level2 {
  background: #150448;
}
.level1_dark .level2 a {
  color: #ffffff;
}
.level1_dark .level3 {
  background: #150448;
}
.level1_dark .level3.collapsed-panel {
  background: #150448;
}
.level1_dark .level2.collapsed-panel {
  background: #150448;
}
.level1_dark a:hover {
  color: #ffffff;
  background: rgba(109, 46, 248, 0.2);
}
.level1_dark i.layout[class$="gray"] {
  color: #ffffff !important;
}
.kye-scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.kye-scrollbar::-webkit-scrollbar-track-piece {
  background-color: transparent;
  border-radius: 5px;
}
.kye-scrollbar::-webkit-scrollbar-thumb {
  cursor: pointer;
  background-color: rgba(157, 156, 164, 0.4);
  border-radius: 5px;
}
.kye-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(157, 156, 164, 0.8);
}
.kye-scrollbar::-webkit-scrollbar-corner {
  display: block;
}
`



// WEBPACK FOOTER //
// ./src/layout/layout/menu-style.js